<template>
	<v-modal class="v-message invoked" @close="$emit('close',$event)" ref="message">
		<div class="message" v-scrollbar>
      <slot/>
    </div>
    <!-- <v-icon name="x-close" @click="close"/> -->
	</v-modal>
</template>

<script>
export default {
  props: {
    duration: {
      default: 3000
    }
  },
  methods: {
    open() {
      this.$refs.message.open();
      if (this.duration > 0) {
        setTimeout(() => this.close(), this.duration);
      }
    },
    close() {
      this.$refs.message.close();
    }
  }
};
</script>

<style lang="less">
.v-modals > .v-modal.v-message {
  // top: 0px;
  max-width: 300px;
  margin: 10px auto;
  position: initial;
  border-width: 1px;
  border-radius: 6px;
  border-style: solid;
  background-color: #ffffff;
  transform: translate3d(0, -100%, 0);
  &.show {
    transform: translate3d(0, 0, 0);
  }
  &[closable] {
    > .content {
      > .v-icon {
        display: inline;
      }
    }
  }
  &[type="info"] {
    color: #1890ff;
    border-color: #1890ff;
  }
  &[type="warn"] {
    color: #fa8c16;
    border-color: #fa8c16;
  }
  &[type="error"] {
    color: #f5222d;
    border-color: #f5222d;
  }
  &[type="success"] {
    color: #52c41a;
    border-color: #52c41a;
  }
  > .content {
    display: flex;
    line-height: 24px;
    align-items: flex-start;
    > .message {
      flex: 1;
      width: 0px;
      max-height: 300px;
      word-break: break-all;
      padding: 8px 15px 8px 15px;
    }
    > .v-icon {
      display: none;
      cursor: pointer;
      margin: 8px 10px 8px 0px;
    }
  }
}
</style>
